
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explore/Ready-to-ship-store",
      function () {
        return require("private-next-pages/explore/Ready-to-ship-store.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/explore/Ready-to-ship-store"])
      });
    }
  